import { useQuery, useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import config from '../config';
import { toast } from 'react-toastify';

export default function useEditStudents() {
  const { studentId } = useParams();
  const [studentDetail, setStudentDetail] = useState({});
  const [loaderOpen, setLoaderOpen] = useState(true);
  const handleClose = () => {
    setLoaderOpen(false);
  };

  const studentMutation = useMutation(async () => {
    const output = await axios.post(config.STUDENTS_API, studentDetail);
    if (output.data.response.status === 'OK') {
      toast.success('Student updates saved', {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } else {
      toast.error('Sorry, something is not right.', {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  });

  const handleFormUpdate = e => {
    setStudentDetail(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleFormSubmission = () => {
    studentMutation.mutate();
  };

  const handleDateFormatting = (newDate, name) => {
    if (newDate) {
      const formattedDate = {
        target: {
          name: name,
          value: newDate,
        },
      };
      handleFormUpdate(formattedDate);
    }
  };

  const submissionLoader = studentMutation.isLoading;

  const { refetch } = useQuery(['getStudentById', studentId], async () => {
    const studentData = new FormData();
    studentData.append('mode', 'getStudentById');
    studentData.append('studentId', studentId);
    studentData.append('auth', localStorage.getItem('token'));

    const output = await axios.post(config.STUDENTS_API, studentData);
    if (output.data.response.status === 'OK') {
      handleClose();
      setStudentDetail(output.data.response.studentData);
      setStudentDetail(prev => ({ ...prev, mode: 'updateStudentWithId' }));
      setStudentDetail(prev => ({
        ...prev,
        auth: localStorage.getItem('token'),
      }));
    } else {
      toast.error('Sorry, something is not right.', {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
  });

  const docDeleteMutation = useMutation(async payload => {
    const docData = new FormData();
    docData.append('mode', 'deleteDocument');
    docData.append('documentName', payload.name);
    docData.append('studentId', studentId);
    docData.append('documentType', payload.type);
    docData.append('auth', localStorage.getItem('token'));
    const output = await axios.post(config.STUDENTS_API, docData);
    if (output.data.response.status === 'OK') {
      toast.success('Document deleted successfully', {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      refetch();
    }
  });

  const handleDocDeletion = (name, type) => {
    const payload = {
      name,
      type,
    };
    if (window.confirm('Are you sure you want to delete this document?')) {
      docDeleteMutation.mutate(payload);
    }
  };

  //UPLOAD FUNCTION
  const handleFileUpload = (e, type) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('inputFile', e.target.files[0]);
    formData.append('function', 'upload');
    formData.append('studentId', studentId);
    formData.append('docType', type);

    axios
      .post(config.API, formData)
      .then(output => {
        if (output.data.response === 'SUCCESS') {
          refetch();
          toast.success('Document uploaded successfully', {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        } else {
          toast.error('Oops, there was an issue uploading the document', {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  // CLEAR DATE FUNCTION
  const clearDate = async type => {
    const formData = new FormData();
    formData.append('mode', 'clearDate');
    formData.append('studentId', studentDetail.student_id);
    formData.append('type', type);
    formData.append('auth', localStorage.getItem('token'));

    const output = await axios.post(config.STUDENTS_API, formData);
    if (output.data.response.status === 'OK') {
      refetch();
    }
  };

  return {
    studentDetail,
    handleClose,
    loaderOpen,
    submissionLoader,
    handleFormUpdate,
    handleFormSubmission,
    handleDateFormatting,
    handleDocDeletion,
    handleFileUpload,
    clearDate,
  };
}
